import { cookies } from "next/headers"
import { NextResponse } from "next/server"
import { clearSession } from "@/services/auth-service"

const WOO_SESSION_COOKIE_PREFIX = "wp_woocommerce_session_"
const STATIC_WOO_COOKIE_NAMES = [
  "woocommerce_store_api_cart_token",
  "woocommerce_cart_hash",
  "woocommerce_items_in_cart",
] as const

const getWooCookieNamesToClear = async (): Promise<string[]> => {
  const cookieStore = await cookies()
  const dynamicSessionCookieNames = cookieStore
    .getAll()
    .filter((cookie) => cookie.name.startsWith(WOO_SESSION_COOKIE_PREFIX))
    .map((cookie) => cookie.name)

  return [
    ...new Set([...STATIC_WOO_COOKIE_NAMES, ...dynamicSessionCookieNames]),
  ]
}

export const POST = async () => {
  await clearSession()

  const response = NextResponse.json({ success: true })
  const wooCookieNamesToClear = await getWooCookieNamesToClear()

  for (const cookieName of wooCookieNamesToClear) {
    response.cookies.delete(cookieName)
  }

  return response
}
